import React, { useState, KeyboardEvent } from 'react';
import { SendIcon } from 'lucide-react';

interface AiChatInputProps {
  onSendMessage: (message: string) => void;
  isTyping: boolean;
}

export const AiChatInput: React.FC<AiChatInputProps> = ({ onSendMessage, isTyping }) => {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (message.trim() && !isTyping) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="p-4 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800">
      <div className="relative">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ask a question..."
          className="w-full pr-12 pl-4 py-3 bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 resize-none"
          rows={1}
          disabled={isTyping}
        />
        <button
          onClick={handleSend}
          disabled={!message.trim() || isTyping}
          className="absolute right-2 top-2 p-2 text-primary-500 hover:text-primary-600 disabled:text-slate-400 disabled:opacity-50 transition-colors"
        >
          <SendIcon size={20} />
        </button>
      </div>
      <div className="text-xs text-center text-slate-400 mt-2">
        AI responses may not be 100% accurate.
      </div>
    </div>
  );
};
